import { PassedInitialConfig } from 'angular-auth-oidc-client';

export const authConfig: PassedInitialConfig = {
  config: {
    authority:
      'https://explorandes.auth.us-east-2.amazoncognito.com/login/continue',
    redirectUrl: 'https://financialsdev.explorandes.app/home',
    clientId: '59vighc1jfv8se0ratipvo3ahq',
    scope: 'email openid phone profile',
    responseType: 'code',
  },
};
